module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("备案申请")]), _vm._v(" "), _c('div', {
    staticClass: "mini-form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("幼儿园")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("小学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("中学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市",
      "prop": "namekey"
    }
  }, [_c('el-cascader', {
    ref: "namekey",
    attrs: {
      "options": _vm.namekeyList,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleNamekeyChange
    },
    model: {
      value: (_vm.formData.namekey),
      callback: function($$v) {
        _vm.$set(_vm.formData, "namekey", $$v)
      },
      expression: "formData.namekey"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "地区选择",
      "prop": "area"
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "certificatenumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.certificatenumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "certificatenumber", $$v)
      },
      expression: "formData.certificatenumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证件照片",
      "prop": "certificatepic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.certificatepic,
      "limit": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传身份证件图片正反面")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QQ",
      "prop": "qq"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入QQ"
    },
    model: {
      value: (_vm.formData.qq),
      callback: function($$v) {
        _vm.$set(_vm.formData, "qq", $$v)
      },
      expression: "formData.qq"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信号",
      "prop": "weixin"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入微信号"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.registstatus == 0 || _vm.formData.registstatus == 3),
      expression: "formData.registstatus==0||formData.registstatus==3"
    }]
  }, [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交备案\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8305f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertDanweiApply.vue
// module id = 1470
// module chunks = 0